<template>
  <div>
    <selectYearChampion />
    <div class="champion">
      <div class="header-bg">
        <img
          v-if="headType === '1'"
          src="../assets/Male/2_Links/standings-bg.jpg"
          alt=""
        />
        <img
          v-if="headType === '2'"
          src="../assets/Female/2_Links/bg.jpg"
          alt=""
        />
      </div>
      <div class="champion-con">
        <p
          class="cham-tit"
          :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
        >
        <span class="sub-tit">{{ $t("champion.sub_title_2024") }}</span> <br/>
          {{ $t("champion.GrandFinal_2024") }}
        </p>
        <!-- grade start -->

        <!-- grate stop -->
        <!-- team-grade start -->
        <div class="team-grade" v-if="championInfo">
          <div class="grade">
            <p class="number">
              {{ championInfo.first_team_grade }} :
              {{ championInfo.second_team_grade }}
            </p>
          </div>
          <div class="team-left">
            <div class="team-img">
              <div class="img-bg">
                <img :src="championInfo.first_team.temp_icon_path_url" alt="" />
              </div>
              <p class="team-name">{{ $t(`${championInfo.first_team_name}`) }}</p>
              <p
                class="view-more"
                @click="
                  viewCom(championInfo.championId, championInfo.first_team_id)
                "
              >
                {{ $t("champion.viewmore") }}
              </p>
            </div>
          </div>
          <div class="team-right">
            <div class="team-img">
              <div class="img-bg">
                <img
                  :src="championInfo.second_team.temp_icon_path_url"
                  alt=""
                />
              </div>
              <p class="team-name">{{ $t(`${championInfo.second_team_name}`) }}</p>
              <p
                class="view-more"
                @click="
                  viewCom(championInfo.championId, championInfo.second_team_id)
                "
              >
                {{ $t("champion.viewmore") }}
              </p>
            </div>
            <div class="triangle"></div>
          </div>
        </div>
        <!-- <div class="coming">
          <h2>{{$t('home.nodata')}}</h2>
        </div> -->
        <div v-if="teamId == championInfo.first_team_id">
          <div class="champion-detial" v-show="viewShow">
            <ViewMore
              v-loading="championloading"
              :TeamMember="firstTeamMember"
              :headList="headList"
              :numList="firstNumList"
              :MemberList="firstMemberList"
              :MemberStats="firstMemberStats"
              :TeamInfo="firstTeamInfo"
              :championInfo="championInfo.first_team_grade"
              @close="close"
            />
          </div>
        </div>
        <div v-if="teamId == championInfo.second_team_id">
          <div class="champion-detial" v-show="viewShow">
            <ViewMore
              v-loading="championloading"
              :TeamMember="secondTeamMember"
              :headList="headList"
              :numList="secondNumList"
              :MemberList="firstMemberList"
              :MemberStats="secondMemberStats"
              :TeamInfo="secondTeamInfo"
              :championInfo="championInfo.second_team_grade"
              @close="close"
            />
          </div>
        </div>
        <!-- team-grade stop -->
        <!-- final mvp start -->
        <div class="final-MVP">
          <div class="average">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.average") }}
            </p>
            <div class="average-num" v-if="championInfo">
              <div class="line">
                <div class="line-info">
                  <span>{{ championInfo.first_team_member_total.POINTS }}</span>
                  <span>POINTS</span>
                  <span>{{
                    championInfo.second_team_member_total.POINTS
                  }}</span>
                </div>
                <div class="isline points-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>
              <div class="line">
                <div class="line-info">
                  <span>{{
                    championInfo.first_team_member_total.ASSISTS
                  }}</span>
                  <span>ASSISTS</span>
                  <span>{{
                    championInfo.second_team_member_total.ASSISTS
                  }}</span>
                </div>
                <div class="isline assists-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>

              <div class="line">
                <div class="line-info">
                  <span>{{
                    championInfo.first_team_member_total.REBOUNDS
                  }}</span>
                  <span>REBOUNDS</span>
                  <span>{{
                    championInfo.second_team_member_total.REBOUNDS
                  }}</span>
                </div>
                <div class="isline rebound-line">
                  <p
                    :class="['red-line', { 'red-line-girl': headType === '2' }]"
                  ></p>
                  <p
                    :class="[
                      'black-line',
                      { 'black-line-girl': headType === '2' }
                    ]"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="mvp-info" v-if="championInfo">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.mvp") }}
            </p>
            <div class="info">
              <div class="img">
                <img :src="championInfo.FMVP.icon_path" alt="" />
              </div>
              <div class="info-box">
                <div class="name-grade">
                  <p class="en-name">
                    {{ $t(championInfo.FMVP.team_name) }}
                    · {{ championInfo.FMVP.number }}
                  </p>
                  <p class="cn-name">{{ $t(championInfo.FMVP.name) }}</p>
                </div>
                <div class="mvp-num">
                  <div class="num-box">
                    <p class="num-name">PTS</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.PTS }}
                    </p>
                  </div>
                  <div class="num-box">
                    <p class="num-name">AST</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.AST }}
                    </p>
                  </div>
                  <div class="num-box">
                    <p class="num-name">REB</p>
                    <p
                      class="num"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    >
                      {{ championInfo.FMVP.REB }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- final mvp stop -->
        <!-- highlight start -->
        <div class="highlght-box">
          <p
            class="champion-tit"
            :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("champion.highlight") }}
          </p>
        </div>
        <Highlight
          :vediolink="vediolink_champion"
          :video="headType == '1' ? video : video_girl"
        />
        <!-- game-gallery start -->
        <div class="game-gallery">
          <div class="review-game" v-show="gaShow">
            <p
              class="champion-tit"
              :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
            >
              {{ $t("champion.back") }}
            </p>
            <div class="review-box">
              <div class="re-header">
                <div class="logo-img">
                  <img src="../assets/ihk-logo.png" alt="" />
                </div>
                <p class="re-tit">
                  {{ $t("champion.ihk") }}
                </p>
              </div>
              <div class="re-img">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/XcbTNajxePg"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <transition name="el-zoom-in-top">
            <div class="gallery" v-show="gaShow">
              <div class="gallery-header">
                <p
                  class="champion-tit"
                  :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                >
                  {{ $t("champion.gallery") }}
                </p>
                <p
                  @click="showgallery"
                  class="see-all"
                  v-scroll-to="{
                    el: '#gallery-title',
                    duration: 500,
                    easing: 'ease',
                    offset: -50,
                    force: true,
                    cancelable: true
                  }"
                >
                  See All <i class="el-icon-right"></i>
                </p>
              </div>
              <!-- <div class="coming"><h2 v-text="watchImg != 0 ? '即將推出' : 'Coming Soon'"></h2></div> -->
              <div class="gallery-imgbox" v-if="championInfo">
                <div
                  class="gallery-img"
                  v-for="(item, index) in championInfo.covers"
                  :key="index"
                  v-loading="galleryloading"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-image
                    class="img"
                    lazy
                    :src="item.temp_photo_path_url"
                    alt=""
                  >
                    <div slot="placeholder" class="image-slot">
                      <i class="el-icon-loading"></i></div
                  ></el-image>
                </div>
              </div>
            </div>
          </transition>

          <transition name="el-fade-in-linear">
            <div class="ga-com" v-show="galleryShow">
              <GalleryCom @toback="toback" :gallery="championInfo.gallery" />
            </div>
          </transition>
        </div>
        <!-- game-gallery stop -->
        <!-- Our media exposures start -->
        <div class="media-exposures">
          <p
            class="champion-tit"
            :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("champion.media") }}
          </p>
          <MediaCom :year="'2024'" :media-list="getMediaList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Highlight from "./components/HighlightVideo.vue";
import { BasketballApi } from "../api/basketball";
import { mapState } from "vuex";
import ViewMore from "./components/champion/ViewMore.vue";
import GalleryCom from "./components/champion/GalleryCom.vue";
import MediaCom from "./components/champion/MediaCom.vue";
import selectYearChampion from "../components/selectYearChampion.vue";

export default {
  components: {
    Highlight,
    ViewMore,
    GalleryCom,
    MediaCom,
    selectYearChampion
  },
  data() {
    return {
      galleryloading: false,
      watchImg: window.localStorage.getItem("watchImg") || 0,
      video: [{ title: "video_title2", text: "video_content2" }],
      video_girl: [{ title: "video_title2", text: "video_content2" }],
      vediolink_champion: "https://www.youtube.com/embed/_2oK4KUMXik",
      championloading: false,
      gaShow: true,
      galleryShow: false,
      viewShow: false,
      viewShow_right: false,
      yearvalue: "2023-2024",
      boy_yearList: [
        {
          label: "2023-2024",
          value: "2024"
        },
        {
          label: "2022-2023",
          value: "2023"
        },
        {
          label: "2021-2022",
          value: "2022"
        },
        {
          label: "2020-2021",
          value: "2021"
        }
      ],
      girl_yearList: [
        {
          label: "2022-2023",
          value: "2023"
        }
      ],
      championInfo_boy: {
        scheduleId: 6,
        championId: "",
        first_team_grade: "35",
        second_team_grade: "41",
        first_team_name: "champion_challenge_boys.first_team_name",
        second_team_name: "champion_challenge_boys.second_team_name",
        first_team_id: 227,
        second_team_id: 222,
        first_team: {
          temp_icon_path_url: require("../assets/champion_info/2023_2024/MTM2729-19X-華富飛魚-LOGO.png")
        },
        second_team: {
          temp_icon_path_url: require("../assets/champion_info/2023_2024/MTM2729-19S-彩福尖子-LOGO.png")
        },
        first_team_member_total: {
          POINTS: "35",
          ASSISTS: "4",
          REBOUNDS: "22"
        },
        second_team_member_total: {
          POINTS: "41",
          ASSISTS: "7",
          REBOUNDS: "16"
        },
        FMVP: {
          icon_path: require("../assets/Boys/mvp.jpg"),
          team_name: "champion_challenge_boys.mvp_team_name",
          number: "7",
          name: "champion_challenge_boys.mvp_name",
          PTS: "12",
          AST: "2",
          REB: "1"
        },
        album_id: 272,
        covers: [],
        gallery: []
      },
      championInfo_girl: {
        scheduleId: 11,
        championId: "",
        first_team_grade: "43",
        second_team_grade: "39",
        first_team_name: "champion_challenge_girls.first_team_name",
        second_team_name: "champion_challenge_girls.second_team_name",
        first_team_id: 110,
        second_team_id: 85,
        first_team: {
          temp_icon_path_url: require("../assets/champion_info/2023_2024/MTM2729-20F-啟晴傾城.png")
        },
        second_team: {
          temp_icon_path_url: require("../assets/champion_info/2023_2024/MTM2729-20H-模範天狼.png")
        },
        first_team_member_total: {
          POINTS: "43",
          ASSISTS: "8",
          REBOUNDS: "27"
        },
        second_team_member_total: {
          POINTS: "39",
          ASSISTS: "6",
          REBOUNDS: "31"
        },
        FMVP: {
          icon_path: require("../assets/Girls/mvp_girl_2024.jpg"),
          team_name: "champion_challenge_girls.mvp_team_name",
          number: "11",
          name: "champion_challenge_girls.mvp_name",
          PTS: "17",
          AST: "1",
          REB: "9"
        },
        album_id: 271,
        covers: [],
        gallery: []
      },
      headList: [],
      firstNumList: [],
      secondNumList: [],
      firstTeamMember: [],
      secondTeamMember: [],
      firstMemberStats: [],
      secondMemberStats: [],
      firstMemberList: [],
      secondMemberList: [],
      firstTeamInfo: "",
      secondTeamInfo: "",
      teamId: "",
      mediaList: [
        {
          title: "media_title1",
          name: "media_name1",
          date: "media_date1",
          media_link:
            "https://hk.on.cc/hk/bkn/cnt/sport/20240601/bkn-20240601173543328-0601_00882_001.html",
          media_img: require("../assets/media/media_2022_1.jpg")
        },
        {
          title: "media_title2",
          name: "media_name2",
          date: "media_date2",
          media_link:
            "https://www.sportsroad.hk/archives/482082",
          media_img: require("../assets/media/media_2022_2.jpg")
        },
        {
          title: "media_title3",
          name: "media_name3",
          date: "media_date3",
          media_link:
            "https://www.etnet.com.hk/www/tc/news/mediaoutreach_news_detail.php?newsid=302907&page=1",
          media_img: require("../assets/media/media_2022_3.jpg")
        }
      ],
      mediaListGirl: [
        {
          title: "media_title1",
          name: "media_name1",
          date: "media_date1",
          media_link: "https://www.sportsroad.hk/archives/482082/%e7%b1%83%e7%90%83%ef%bd%9c%e5%bd%a9%e7%a6%8f%e5%b0%96%e5%ad%90-%e5%95%9f%e6%99%b4%e5%82%be%e5%9f%8e%e3%80%8a%e9%82%a8jump%ef%bc%81%e3%80%8b%e7%b1%83%e7%90%83%e8%81%af%e8%b3%bd%e7%a8%b1%e7%8e%8b/",
          media_img: require("../assets/media/mediagirl_2024.jpg")
        },
        {
          title: "media_title2",
          name: "media_name2",
          date: "media_date2",
          media_link:
            "https://hk.on.cc/hk/bkn/cnt/sport/20240601/bkn-20240601162212617-0601_00882_001.html",
          media_img: require("../assets/media/mediagirl2_2024.jpg")
        },
        {
          title: "media_title3",
          name: "media_name3",
          date: "media_date3",
          media_link:
            "https://www.etnet.com.hk/www/tc/news/mediaoutreach_news_detail.php?newsid=302907&page=1",
          media_img: require("../assets/media/mediagirl3_2024.jpg")
        }
      ],
      boy_team_info: {},
      firl_team_info: {}
    };
  },
  computed: {
    ...mapState(["headType"]),
    getMediaList() {
      if (this.headType === "1") {
        return this.mediaList;
      } else {
        return this.mediaListGirl;
      }
    },
    championInfo() {
      if (this.headType === "1") {
        return this.championInfo_boy;
      } else {
        return this.championInfo_girl;
      }
    },
    yearVal() {
      if (this.headType == "1") {
        return this.boy_yearList;
      } else {
        return this.girl_yearList;
      }
    }
  },
  methods: {
    async getHighlightAlbum() {
      await BasketballApi.getHighlightAlbum(this.championInfo.album_id).then(
        (res) => {
          this.championInfo.covers = res.slice(0, 4);
          this.championInfo.gallery = res;
            console.log(
          'gallery',
          JSON.parse(JSON.stringify(this.championInfo.gallery))
        )
        }
      );
    },
    close() {
      this.viewShow = false;
      this.championInfo.championId = null;
    },
    showgallery() {
      this.galleryShow = !this.galleryShow;
      // console.log('galleryShow', this.championInfo.gallery)
           console.log(
          'gallery',
          JSON.parse(JSON.stringify(this.championInfo.gallery))
        )
      this.gaShow = !this.gaShow;
    },
    toback() {
      this.galleryShow = !this.galleryShow;
      this.gaShow = !this.gaShow;
    },
    viewCom(id, type) {
      this.championInfo.championId = id;
      this.teamId = type;
      this.viewShow = !this.viewShow;
      // this.getScheduleRoundsList();
    },
    getChampion() {
      this.championloading = true;
      this.galleryloading = true;
      this.headType;
      BasketballApi.getChampion().then((res) => {
        this.championInfo = res;
        this.championloading = false;
        this.galleryloading = false;
      });
    },
    getScheduleRoundsList() {
      BasketballApi.getScheduleRoundsList(
        "1",
        this.championInfo.scheduleId,
        "",
        "",
        "",
        "",
        "2024"
      ).then((res) => {
        this.roundsList = res.competitions;
        if (this.roundsList && this.roundsList[0]) {
          this.championInfo.championId = this.roundsList[0].id;
          
          this.getCompetitionDeatils();
        } else {
          this.championInfo.championId = [];
        }
        console.log('getScheduleRoundsList', this.championInfo.championId)
      });
    },
    getCompetitionDeatils() {
      this.championloading = true;
      this.headType;
      BasketballApi.getCompetitionDeatils(this.championInfo.championId).then(
        (res) => {
          this.headList = Object.keys(res.first_team_member_total);
          this.firstNumList = res.first_team_member_total;
          this.secondNumList = res.second_team_member_total;
          this.firstTeamMember = res.first_team_members;
          this.secondTeamMember = res.second_team_members;
          this.firstTeamInfo = res.first_team;
          this.secondTeamInfo = res.second_team;
          let arr1 = [];
          let arr2 = [];
          let arr3 = [];
          let arr4 = [];
          res.first_team_members.forEach((item) => {
            this.list1 = Object.values(item);
            this.list2 = Object.keys(item);
            arr1.push(this.list1.slice(5, 20));
            arr2.push(this.list2.slice(5, 20));
          });
          res.second_team_members.forEach((item) => {
            this.list1 = Object.values(item);
            this.list2 = Object.keys(item);
            arr3.push(this.list1.slice(5, 20));
            arr4.push(this.list2.slice(5, 20));
          });
          this.firstMemberStats = res.first_team_members;
          this.firstMemberList = arr2;
          this.secondMemberStats = res.second_team_members;
          this.secondMemberList = arr4;
          this.secondTeamMember = res.second_team_members;
          this.championloading = false;
        }
      );
    }
  },
  created() {
    this.getHighlightAlbum();
    this.getScheduleRoundsList();
    // this.getChampion();
  }
};
</script>
<style lang="scss">
.champion {
  .el-image {
    .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.champion {
  background: #c5cfe348;
  padding-bottom: 70px;
  .coming {
    height: 200px;
    line-height: 100px;
    font-size: 30px;
    color: #e1e5eb9c;
  }
  .champion-tit {
    font-size: 25px;
    color: #5aa2d3;
    font-weight: 600;
    text-align: left;
    margin: 20px 35px;
  }
  .header-bg {
    height: 270px;
    img {
      width: 100%;
      height: 270px;
      object-fit: cover;
      object-position: top;
      // height: 100%;
    }
  }
  .champion-con {
    margin-top: -240px;
    width: 90%;
    margin-left: 5%;
    .grade {
      position: absolute;
      left: 45%;
      top: 33%;
      // background: rgb(205, 228, 209);
      z-index: 10;
      .number {
        font-size: 50px;
        font-weight: 600;
        color: #fff;
        letter-spacing: 2px;
      }
    }
    .cham-tit {
      font-size: 30px;
      color: #fff;
      margin: 30px 0;
      font-weight: 600;
    }
    .sub-tit {
      font-size: 21px;
    }
    .team-grade {
      display: flex;
      position: relative;
      border-radius: 15px;
      overflow: hidden;
      height: 250px;
      .team-img {
        .img-bg {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #fff;
          overflow: hidden;
          margin: auto;
          margin-top: 40px;
          img {
            margin-top: 18px;
            width: 80px;
            height: 80px;
            // object-fit: cover;
            // object-position: center;
            // border-radius: 50%;
          }
        }
        .team-name {
          font-size: 16px;
          margin-top: 8px;
          color: #fff;
        }
        .view-more {
          color: #fff;
          border: 1px solid #000;
          margin-top: 10px;
          display: inline-block;
          border-radius: 15px;
          padding: 5px 25px 5px 25px;
          cursor: pointer;
        }
        .view-more:hover {
          background: rgba(0, 0, 0, 0.493);
        }
      }
      .team-left {
        width: 50%;
        background: #870014;
        // height: 200px;
      }
      .team-right {
        width: 55%;
        background: #2d3b51;
        // height: 240px;
        position: relative;
        .triangle {
          z-index: 1;
          position: absolute;
          width: 0;
          height: 0;
          border-top: 250px solid #870014;
          border-right: 100px solid transparent;
          top: 0;
          left: 0;
        }
      }
    }
    //final mvp style start
    .final-MVP {
      margin-top: 30px;
      display: flex;
      // margin-bottom: 100px;
      .average {
        background: #fff;
        width: 65%;
        border-radius: 15px;
        box-shadow: 2px 2px 15px #8888886c;
        padding-bottom: 20px;
        .average-num {
          margin: 0 35px;
          .line {
            margin-bottom: 25px;
            .line-info {
              text-align: left;
              display: flex;
              justify-content: space-between;
            }
            .isline {
              display: flex;
              .red-line,
              .red-line-girl {
                width: 50%;
                height: 4px;
                background: #870014;
                border-radius: 2px;
              }
              .black-line,
              .black-line-girl {
                width: 50%;
                height: 4px;
                background: rgb(0, 0, 0);
                margin-left: 5px;
                border-radius: 2px;
              }
            }
            .points-line {
              .red-line {
                width: 46%;
              }
              .black-line {
                width: 54%;
              }
            }
            .points-line {
              .red-line.red-line-girl {
                width: 52%;
              }
              .black-line.black-line-girl {
                width: 48%;
              }
            }
            .assists-line {
              .red-line {
                width: 36%;
              }
              .black-line {
                width: 64%;
              }
            }
            .assists-line {
              .red-line.red-line-girl {
                width: 57%;
              }
              .black-line.black-line-girl {
                width: 43%;
              }
            }
            .rebound-line {
              .red-line {
                width: 57%;
              }
              .black-line {
                width: 43%;
              }
            }
            .rebound-line {
              .red-line.red-line-girl {
                width: 46%;
              }
              .black-line.black-line-girl {
                width: 54%;
              }
            }
          }
        }
      }
      .mvp-info {
        box-shadow: 2px 2px 15px #8888886c;
        margin-left: 30px;
        background: #fff;
        width: 35%;
        border-radius: 15px;
        .info {
          display: flex;
          .img {
            width: 140px;
            height: 140px;
            background: rgb(228, 77, 77);
            border-radius: 50%;
            margin-left: 30px;
            margin-bottom: 25px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: top;
              border-radius: 50%;
            }
          }
          .info-box {
            width: 200px;
            // background: rgb(162, 181, 223);
            margin: 0 30px;
            .name-grade {
              text-align: left;
              margin-bottom: 15px;
              border-bottom: 2px solid #c5cfe348;
              .en-name {
                font-size: 12px;
              }
              .cn-name {
                font-size: 17px;
                font-weight: 600;
                margin-bottom: 10px;
              }
            }
            .mvp-num {
              display: flex;
              justify-content: space-around;
              .num-box {
                border-right: 2px solid #c5cfe348;
                padding: 0 20px;
                .num-name {
                  font-size: 12px;
                }
                .num {
                  font-size: 22px;
                  font-weight: 600;
                  color: #4e8ac3;
                }
              }
              :nth-child(3) {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .highlght-box {
      margin-bottom: 100px;
    }
    //game-gallery start
    .game-gallery {
      display: flex;
      width: 100%;
      margin: 40px 0;
      // margin-left: 5%;
      .review-game {
        width: 50%;
        background: #fff;
        box-shadow: 2px 2px 15px #8888886c;
        border-radius: 15px;
        padding-bottom: 50px;
        .review-box {
          .re-header {
            display: flex;
            margin: 0 0 15px 35px;
            .logo-img {
              width: 45px;
              height: 45px;
              border-radius: 50%;
              border: 2px solid rgba(184, 182, 182, 0.397);
              padding-top: 8px;
              img {
                width: 100%;
              }
            }
            .re-tit {
              line-height: 50px;
              margin-left: 20px;
              font-weight: 600;
              font-size: 17px;
            }
          }
          .re-img {
            width: 87%;
            height: 270px;
            margin-left: 35px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 10px;
            }
          }
        }
      }
      .gallery {
        width: 50%;
        background: #fff;
        box-shadow: 2px 2px 15px #8888886c;
        border-radius: 15px;
        margin-left: 30px;
        .gallery-header {
          display: flex;
          justify-content: space-between;
          .see-all {
            margin: 30px 35px;
            font-size: 12px;
            cursor: pointer;
            i {
              color: #5aa2d3;
            }
          }
        }
        .gallery-imgbox {
          display: flex;
          width: 88%;
          margin-left: 6%;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-bottom: 30px;
          .gallery-img {
            width: 49%;
            // margin-left: 3%;

            .img {
              margin-top: 5px;
              width: 100%;
              height: 200px;
              border-radius: 10px;
            }
          }
        }
      }
    }
    //media
    .media-exposures {
      background: #fff;
      width: 100%;
      border-radius: 20px;
      padding: 15px 0 40px 0;
      box-shadow: 2px 2px 15px #8888886c;
      .media-box {
        display: flex;
        justify-content: space-around;
        padding: 0 25px;
        .media-img {
          width: 13%;
          // margin-left: 8px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .champion {
    .champion-con {
      .team-grade {
        height: 300px;
        .grade {
          left: 25%;
          top: 3%;
        }
        .team-left,
        .team-right {
          .team-img {
            margin-top: 90px;
            .img-bg {
              width: 80px;
              height: 80px;
              img {
                width: 60px;
                height: 60px;
                margin-top: 5px;
              }
            }
          }
        }
        .team-right {
          .triangle {
            border-top: 300px solid #870014;
            border-right: 40px solid transparent;
            left: -0.5;
          }
        }
      }
      .final-MVP {
        flex-direction: column;
        .average {
          width: 100%;
        }
        .mvp-info {
          width: 100%;
          margin-left: 0;
          margin-top: 20px;
          padding-bottom: 20px;
          .info {
            justify-content: space-between;
            .img {
              width: 40%;
              background: #fff;
              margin-left: 20px;
              img {
                width: 90px;
                height: 90px;
              }
            }
            .info-box {
              width: 60%;
              .name-grade {
                padding-left: 20px !important;
              }
            }
          }
        }
      }
      .game-gallery {
        flex-direction: column;
        .review-game {
          width: 100%;
          .review-box {
            .re-img {
              width: 90%;
              margin-left: 5%;
            }
          }
        }
        .gallery {
          width: 100%;
          margin-left: 0;
          height: 390px;
          margin-top: 20px;
          .gallery-imgbox {
            .gallery-img {
              .img {
                height: 130px;
                img {
                  object-fit: cover;
                  object-position: center;
                }
              }
            }
          }
        }
      }
      .media-exposures {
        .media-com {
          flex-direction: column;
        }
      }
    }
  }
}
</style>